import { render, staticRenderFns } from "./XDesk.vue?vue&type=template&id=4384f554&"
import script from "./XDesk.vue?vue&type=script&lang=js&"
export * from "./XDesk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports